import { useDispatch } from 'react-redux';

import type { store } from 'entrypoints/bootstrapOnClient';

export const useThunkDispatch = () => useDispatch<typeof store.dispatch>();
